import type { PortfolioItem } from "@/features/portfolio-items/types";
import { PublicEmpty } from "@/pages/public/PublicState";
import { PortfolioCard } from "./PortfolioCard";

interface PortfolioGridProps {
  items: PortfolioItem[];
}

export function PortfolioGrid({ items }: PortfolioGridProps) {
  if (items.length === 0) {
    return (
      <PublicEmpty
        title="No portfolio items found"
        description="Try a different category, search term, or sort option."
      />
    );
  }

  return (
    <div className="grid min-w-0 gap-5 md:grid-cols-2 xl:grid-cols-3 xl:gap-6">
      {items.map((item) => (
        <PortfolioCard key={item.id} item={item} />
      ))}
    </div>
  );
}
